import { QueryComponentsCollection } from "./../collections/query-components";
import { AuthorizationModel } from "./../../authentication/models/authorization-model";
import { AppSettings } from "./../../app-settings";

export class AutoCorrect {
    public static GetTitleCorrection(components: QueryComponentsCollection): Promise<string> {
        let request: JQueryXHR;
        const title = components.first().Fragment;
        const field = components.first().FieldName;
        return new Promise((resolve, reject) => {
            request = $.ajax({
                url: `${AppSettings.AutoCorrectApiUrlPrefix}title/${title}` ,
                type: "GET",
                success: (data: ICorrectionResponse) => {
                    resolve(this.ParseResults(title, field, data));
                }, error: () => {
                    reject();
                },
                beforeSend: AuthorizationModel.attachAuthorizationHeader
            });

            setTimeout(() => {
                if (request && request.state() === "pending") {
                    request.abort();
                    request = null;
                    resolve();
                }
            }, 7000);
        });
    }

    private static ParseResults(title: string, field: string, data: ICorrectionResponse): string {
        if (data && data.EngineReady && data.CorrectionCandidates.length) {
            const correction = data.CorrectionCandidates[0].Value.Title;
            if (correction.toLowerCase() === title.toLowerCase()) {
                return "";
            }
            if (field === "Anywhere") {
                return correction;
            } else {
                return `Title[${correction}]`;
            }
        }
        return "";
    }
}

interface ICorrectionResponse {
    CorrectionCandidates: ICorrectionCandidate[];
    EngineReady: boolean;
}

interface ICorrectionCandidate {
    Value: ITitleResult;
    Score: number;
    Algorithm: CorrectionAlgorithm;
}

interface ITitleResult {
    Title: string;
    Score: number;
}

enum CorrectionAlgorithm {
    Partial,
    Sequence,
    Distance,
    Token
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/search/helpers/auto-correct.ts